import request from '@/utils/request';

// post /api/v1/admin/game_config/vip/desc/update
export function updateVipRuleDesc(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/desc/update',
    method: 'post',
    data,
    mock: false
  })
}

// post /api/v1/admin/game_config/vip/desc/get
export function getVipRuleDesc(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/desc/get',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/list
export function getVipList(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/list',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/get
export function getVipDetail(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/get',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/create
export function createVip(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/create',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/update
export function updateVip(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/update',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/update_bonus_data
export function updateBonusData(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/update_bonus_data',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/delete
export function deleteVip(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/delete',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/vip/player_vip_level_list
export function getPlayerVipLevelList(data) {
  return request({
    url: '/api/v1/admin/game_config/vip/player_vip_level_list',
    method: 'post',
    data,
    mock: false,
  })
}
